export const QUERY_KEYS = { NEETO_APPS_LIST: "neeto-apps-list" };

export const SPECIAL_APP_NAMES = { bugwatch: "BugWatch" };
